import Dashboard from './Pages/WorkSpace/WorkSpace';
import { NEW_DAILOG, WORKSAPCE, SAVED_CHATS, SETTINGS, USAGE } from './Common/Constants';
import { Route, Routes } from 'react-router-dom';
import SavedChats from './Pages/SavedChats/SavedChats';
import Settings from './Pages/Settings/Settings';
import ChatBotComponent from './Pages/ChatBotComponent/ChatBotComponent';
import { LoginCallback } from "@okta/okta-react";
import { RequiredAuth } from './Common/Okta/SecureRoute';
import Usage from './Pages/Usage/Usage';
import ChatPage from './Pages/ChatPage'; // Import the new ChatPage component

export default
    <>
        <Routes>
            <Route element={<RequiredAuth />}>
                <Route path={NEW_DAILOG} element={<ChatPage />}> </Route>
                <Route path={WORKSAPCE} element={<Dashboard />}></Route>
                <Route path={SAVED_CHATS} element={<SavedChats />}></Route>
                <Route path={SETTINGS} element={<Settings />}></Route>
                <Route path={USAGE} element={<Usage />}></Route>
            </Route>

            <Route path="/login/callback" element={<LoginCallback />} />

        </Routes>
    </>
